import classNames from "classnames";
import { useFormikContext } from "formik";
import React from "react";
import { Accordion } from "react-bootstrap";

import { IFormITR1 } from "../../../config/interfaces";
import PriceDisplay from "../../PriceDisplay";
import { ContextAwareToggle } from "../../accordion";

type Props = {};

const AccBusinessProfessionalIncome: React.FC<Props> = (props: Props) => {
  const { values } = useFormikContext<IFormITR1>();

  return (
    <>
      {values.TotalBusOrProfIncome ? (
        <>
          <Accordion.Item eventKey="income-source-3">
            <ContextAwareToggle eventKey="income-source-3" isChild={true}>
              <div className="btn-content justify-content-between">
                <p className="leading-para fw-bold mb-0">Business And Professional Income</p>
                <p className="leading-para fw-bold mb-0">
                  <PriceDisplay price={values.TotalBusOrProfIncome} />
                </p>
              </div>
            </ContextAwareToggle>
            <Accordion.Body>
              <section>
                <dl className="eds-list eds-dl eds-inline-between">
                  <RenderListItem
                    title="Professional Income (Revenue < 75 lakhs)"
                    amount={values.BusOrProfIncomes.PISection44ADA}
                  />

                  <RenderListItem
                    title="Business Income (Revenue more than 3 crores)"
                    amount={values.BusOrProfIncomes.BISection44AD}
                  />

                  <RenderListItem
                    title="Financial Particulars - Total Liabilities"
                    amount={values.BusOrProfIncomes.TotalLiabilities}
                  />

                  <RenderListItem
                    title="Financial Particulars - Total Assets"
                    amount={values.BusOrProfIncomes.TotalAssets}
                  />

                  <RenderListItem
                    title="Total:"
                    amount={values.TotalBusOrProfIncome}
                    isSubtotal={true}
                  />
                </dl>
              </section>
            </Accordion.Body>
          </Accordion.Item>
        </>
      ) : null}
    </>
  );
};

export default AccBusinessProfessionalIncome;

const RenderListItem = ({
  amount,
  title,
  isSubtotal = false
}: {
  amount: number;
  title: string;
  isSubtotal?: boolean;
}) => {
  return (
    <>
      {amount ? (
        <div className={classNames("eds-list--item", isSubtotal && "eds-list--item-subtotal")}>
          <dt>{title}</dt>
          <dd>
            <PriceDisplay price={amount} />
          </dd>
        </div>
      ) : null}
    </>
  );
};
